(function () {
  "use strict";

  var MAX_GSAP_WAIT = 60;

  function waitForGsap(callback) {
    if (typeof window.zeusWhenGsapReady === "function") {
      window.zeusWhenGsapReady(callback);
      return;
    }
    var waitTicks = 0;
    function poll() {
      if (window.gsap && window.ScrollTrigger) {
        callback();
        return;
      }
      waitTicks += 1;
      if (waitTicks < MAX_GSAP_WAIT) {
        window.requestAnimationFrame(poll);
      }
    }
    poll();
  }

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function killCardTriggers(root) {
    var ScrollTrigger = window.ScrollTrigger;
    if (!ScrollTrigger) return;
    ScrollTrigger.getAll()
      .filter(function (t) {
        return t.vars && t.vars.trigger && root.contains(t.vars.trigger);
      })
      .forEach(function (t) {
        t.kill();
      });
  }

  function initReveal(root) {
    if (!root || root.getAttribute("data-card-reveal") !== "true") return;
    if (prefersReducedMotion()) return;
    if (root.dataset.zeusFeaturedRevealInit === "true") return;

    function bind() {
      var gsap = window.gsap;
      var ScrollTrigger = window.ScrollTrigger;
      if (!gsap || !ScrollTrigger) return false;

      var cards = root.querySelectorAll(".zeus-featured-boards__card-wrapper");
      if (!cards.length) return false;

      gsap.registerPlugin(ScrollTrigger);

      // Kill any leftover triggers scoped to this root before re-binding.
      killCardTriggers(root);

      root.dataset.zeusFeaturedRevealInit = "true";
      root.classList.add("is-gsap-reveal");

      ScrollTrigger.batch(cards, {
        start: "top 88%",
        once: true,
        onEnter: function (batch) {
          gsap.from(batch, {
            opacity: 0,
            y: 28,
            duration: 0.65,
            ease: "power2.out",
            stagger: 0.1,
            clearProps: "transform",
          });
        },
      });

      if (typeof window.zeusScrollTriggerRefresh === "function") {
        window.zeusScrollTriggerRefresh();
      } else {
        ScrollTrigger.refresh();
      }
      return true;
    }

    waitForGsap(bind);
  }

  function init(root) {
    initReveal(root);

    var recommendations = root.closest(".shopify-section")?.querySelector("product-recommendations");
    if (!recommendations || recommendations.dataset.zeusFeaturedObserved === "true") return;

    recommendations.dataset.zeusFeaturedObserved = "true";

    var observer = new MutationObserver(function (mutations, obs) {
      // Disconnect as soon as recommendation cards have been injected so we
      // do not fire again on subsequent DOM mutations (e.g. lazy-load images).
      var hasCards = root.querySelectorAll(".zeus-featured-boards__card-wrapper").length > 0;
      if (hasCards) {
        obs.disconnect();
        recommendations.dataset.zeusFeaturedObserved = "false";
        document.dispatchEvent(new CustomEvent("zeus:rail:refresh"));
      }

      // Reset the reveal flag so initReveal arms fresh triggers.
      root.dataset.zeusFeaturedRevealInit = "false";
      initReveal(root);
    });

    observer.observe(recommendations, { childList: true, subtree: true });
  }

  function boot() {
    document.querySelectorAll("[data-zeus-featured-boards]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-zeus-featured-boards]");
    if (!root) return;

    // Kill stale triggers before re-init on theme editor section reload.
    killCardTriggers(root);
    root.dataset.zeusFeaturedRevealInit = "false";

    // Reset the observer sentinel so a fresh observer is attached.
    var recommendations = event.target.querySelector("product-recommendations");
    if (recommendations) {
      recommendations.dataset.zeusFeaturedObserved = "false";
    }

    init(root);
  });
})();
